<template>
  <v-menu v-model="timePickerOpen" :max-width="260" :min-width="260" :close-on-content-click="false" content-class="UXDatapicker">
    <template v-slot:activator="{ on }">
      <div class="UXdatetimeInput" :class="{ outline: !isOutline }" v-on="on">
        <span v-if="isTimeValue">{{ hour ? hour : '00' }}시 {{ minute ? minute : '00' }}분</span>
        <span v-else-if="isHourValue">{{ hour ? hour : '00' }}시간 {{ minute ? minute : '00' }}분</span>
        <span v-else>{{ hour ? hour : '00' }}:{{ minute ? minute : '00' }}</span>
        <input type="hidden" v-model="value" />
        <i class="UXicon-down"></i>
      </div>
    </template>

    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong>
            <span v-if="hour || minute">
              <span v-if="isTimeValue">{{ hour ? hour + '시 ' : '' }}</span>
              <span v-else-if="isHourValue">{{ hour ? hour + '시간 ' : '' }}</span>
              {{ minute ? minute + '분 ' : '' }}
            </span>
            <span v-else>시간선택</span>
          </strong>
        </p>
        <div class="endBtn" v-if="hour && minute">
          <v-btn dark color="#5578F0" @click="setTime">완료</v-btn>
        </div>
      </div>

      <div class="con2">
        <div class="timeBox">
          <dl>
            <dt v-if="isTimeValue">{{ hour ? hour : '00' }}시</dt>
            <dt v-else-if="isHourValue">{{ hour ? hour : '00' }}시간</dt>
            <dd>
              <perfect-scrollbar>
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a v-if="isTimeValue" :class="{ on: hour === item }" @click="hour = item">{{ item }}시</a>
                    <a v-else-if="isHourValue" :class="{ on: hour === item }" @click="hour = item">{{ item }}시간</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
          <dl>
            <dt>{{ minute ? minute : '00' }}분</dt>
            <dd>
              <perfect-scrollbar>
                <ul v-if="!(hour === 24 || hour === '24')">
                  <li v-for="(item, index) in minutes" :key="index">
                    <a :class="{ on: minute == item }" @click="minute = item">{{ item }}분</a>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <a :class="{ on: minute == '00' }" @click="minute = '00'">00분</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'TimePicker',
  data() {
    return {
      timePickerOpen: false,
      hours: [],
      minutes: [],
      hour: '',
      minute: ''
    };
  },
  props: {
    value: {
      type: String,
      required: false
    },
    minuteScope: {
      type: Number,
      required: false
    },
    isOutline: {
      type: Boolean,
      default: false,
      required: false
    },
    maxHour: {
      type: Number,
      required: false
    },
    isTimeValue: {
      // '00시' 표기
      type: Boolean,
      default: true,
      required: true
    },
    isHourValue: {
      // '00시간' 표기
      type: Boolean,
      default: false,
      required: false
    }
  },
  created() {
    const minuteScopeNum = !this.minuteScope ? 5 : this.minuteScope < 60 ? this.minuteScope : 5;
    const maxHour = !this.maxHour ? 24 : this.maxHour < 25 ? this.maxHour : 24;
    for (let i = 0; i < 60; i++) {
      let num = i.toString().length > 1 ? i : '0' + i.toString();
      if (this.hours.length <= maxHour && i >= 0) {
        this.hours.push(num);
      }
      if (i % minuteScopeNum === 0) {
        this.minutes.push(num);
      }
    }

    setTimeout(() => {
      this.resetTime();
    }, 50);
  },
  watch: {
    timePickerOpen(val) {
      this.resetTime();
    },
    value(val) {
      this.resetTime();
    }
  },
  methods: {
    resetTime() {
      if (this.value) {
        let time = this.value.split(':');
        this.hour = time[0];
        this.minute = time[1];
      }
    },
    setTime() {
      this.$emit('input', this.hour + ':' + this.minute);
      this.timePickerOpen = false;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/TimePicker.vue